import React from "react";
import { Section, Reveal, Eyebrow, SectionTitle, CTAButton } from "./ui";
import { problems } from "./data";
export function Problems() {
  return <Section id="identificacion" className="bg-white" data-id="element-180" data-mp="36xuc5149vdod">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-181" data-mp="3249dd6uuufo4">
        <Eyebrow data-id="element-182" data-mp="322oghal2ikn3">Cuando ya probaste todo</Eyebrow>
        <SectionTitle data-id="element-183" data-mp="2y2e7dp1zbe40">Repetir más fuerte no es tener una estrategia.</SectionTitle>
      </Reveal>

      <Reveal delay={0.06} data-id="element-184" data-mp="2t5e1be54qbcw">
        <div className="mx-auto mt-6 max-w-3xl rounded-2xl border-l-4 border-[var(--accent)] bg-[#f4f9ff] p-5 text-left sm:mt-8 sm:rounded-3xl sm:p-8" data-id="element-185" data-mp="2t5nwrh8y1apz">
          <p className="text-sm leading-relaxed text-[var(--muted)] sm:text-[17px]" data-id="element-186" data-mp="2j5ev3nw6mx37">
            Sentir que ya probaste todo —explicar, gritar, repetir, insistir— y que nada cambia,
            es agotador.{" "}
            <span className="font-bold text-[var(--ink)]" data-id="element-187" data-mp="hdsdgcy6keje">
              El problema no es tu hijo, y tampoco sos vos.
            </span>{" "}
            El problema es que te faltan herramientas específicas para una forma diferente de
            procesar el mundo. Entender cómo funciona su atención y sus emociones cambia las
            reglas del juego.
          </p>
        </div>
      </Reveal>

      <ul className="mt-6 grid gap-2.5 sm:mt-8 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3" data-id="element-188" data-mp="2vr892jot4n0x">
        {problems.map((p, i) => <Reveal key={p.text} delay={i % 3 * 0.05} data-id="element-189" data-mp="2zs1yjhhwe9vx" data-mpi={i}>
            <li className="flex h-full items-start gap-3 rounded-2xl border border-[#e6eef5] bg-[#fbfdff] p-4 text-left sm:p-5" data-id="element-190" data-mp="3nh2yegco0cpl">
              <span className="text-xl leading-none" aria-hidden data-id="element-191" data-mp="3sfxqya0fpfmw">
                {p.emoji}
              </span>
              <p className="text-[13px] leading-snug text-[var(--muted)] sm:text-sm sm:leading-relaxed" data-id="element-192" data-mp="3eoso6z1rs78c">
                {p.text}
              </p>
            </li>
          </Reveal>)}
      </ul>

      <Reveal delay={0.1} className="mt-8 text-center sm:mt-10" data-id="element-193" data-mp="a9jbg6mioxme">
        <CTAButton data-id="element-194" data-mp="f2kv0rxo5lcb">Quiero dejar de improvisar</CTAButton>
      </Reveal>
    </Section>;
}